import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useOutletContext, useParams } from "react-router";

import ModernBanner from "../shopping/component/themes/modern/banner";
import CuteBanner from "../shopping/component/themes/cute/banner";
import ChicBanner from "../shopping/component/themes/chic/banner";
import SimpleBanner from "../shopping/component/themes/simple/banner";
// import DefaultBanner from "../shopping/component/themes/default/banner";

import { BsClock } from "react-icons/bs";
import { FaUserPen } from "react-icons/fa6";

import { Container } from "../common/styled";
import { ViewerContainer, DetailSection } from "../portfolio/portfolioView/styled";

const ShoppingNoticeView = () => {
  const navigate = useNavigate();
  const { theme, menus, url } = useOutletContext();
  const [notice, setNotice] = useState();

  const { noticeNo } = useParams();

  const getNotice = async () => {
    const url = "/api/notice";
    const body = { noticeNo: noticeNo };

    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        console.log(res.data);
        setNotice(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getNotice();
  }, []);

  const banners = {
    0: ModernBanner,
    1: ChicBanner,
    2: ModernBanner,
    3: CuteBanner,
    4: SimpleBanner,
  };

  const renderComponent = () => {
    const Banner = banners[theme];

    return (
      <>
        {Banner && <Banner />}
        <ViewerContainer className={`theme-${theme}`}>
          <h3>
            <span>공지사항</span>
          </h3>
          <DetailSection className={`theme-${theme}`}>
            <div className="info">
              <p>{notice?.noticeSj}</p>
              <div className="details">
                <span>
                  <FaUserPen />
                  {notice?.createMberId}
                </span>
                <span>
                  <BsClock /> {notice?.updateDt || notice?.createDt}
                </span>
              </div>
              <button onClick={() => navigate(`/shop/${url}/shoppingNotice?page=0`)}>
                전체 공지 보기
              </button>
            </div>
            <div className="contents">
              <div dangerouslySetInnerHTML={{ __html: notice?.noticeCn || "" }}></div>
            </div>
            <div className="buttons">
              <button
                onClick={() => navigate(`/shop/${url}/shoppingNotice?page=0`)}
                className="nav">
                목록
              </button>
            </div>
          </DetailSection>
        </ViewerContainer>
      </>
    );
  };

  return <Container className={`theme-${theme}`}>{renderComponent()}</Container>;
};

export default ShoppingNoticeView;
